import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";

import {
  changeOrdersStatusAdminServices,
  changePasswordService,
  changePinService,
  changeStoreStatusAdminServices,
  confirmChangePasswordService,
  getOrdersStatusPublicService,
  getStoreStatusAdminService,
  getOrderiStatusPublicService,
  changeOrderiStatusAdminServices,
  smsStatusAdminServices,
} from "../../../services/userServices";

export const changePasswordAdminContext = createContext({
  phonenumber: "",
  setPhonenumber: () => {},
  isCodeSent: null,
  setIsCodeSent: () => {},
  isOpenChangePasswordModal: null,
  setIsOpenChangePasswordModal: () => {},
  handleChangePassword: () => {},
  handleConfirmChangePassword: () => {},
  changePin: "",
  setChangePin: () => {},
  confirmChangePin: "",
  setConfirmChangePin: () => {},
  isOpenChangePinModal: null,
  setIsOpenChangePinModal: () => {},
  handleChangePin: () => {},
  pinPhoneNumber: "",
  setPinPhoneNumber: () => {},
  pinPassword: "",
  setPinPassword: () => {},
  //* Store Status
  isStoreClose: null,
  setIsStoreClose: () => {},
  handleChangeStoreStatus: () => {},
  handleGetStoreStatus: () => {},
  //* Orders Status
  isOrdersClose: null,
  setIsOrdersClose: () => {},
  handleGetOrdersStatus: () => {},
  handleChangeOrdersStatus: () => {},
  //* Send Message By Admin
  handleSendMessageByAdmin: () => {},
  //* Orderi Status
  isOrderiClose: null,
  setIsOrderiClose: () => {},
  handleGetOrderiStatus: () => {},
  handleChangeOrderiStatus: () => {},
});

const ChangePasswordAdminContext = ({ children }) => {
  const dispatch = useDispatch();

  const [phonenumber, setPhonenumber] = useState("");
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [isOpenChangePasswordModal, setIsOpenChangePasswordModal] =
    useState(false);
  const [isOpenChangePinModal, setIsOpenChangePinModal] = useState(false);

  const [changePin, setChangePin] = useState("");
  const [confirmChangePin, setConfirmChangePin] = useState("");
  const [pinPhoneNumber, setPinPhoneNumber] = useState("");
  const [pinPassword, setPinPassword] = useState("");

  //* Store Status
  const [isStoreClose, setIsStoreClose] = useState(null);

  //* Orders Status
  const [isOrdersClose, setIsOrdersClose] = useState(null);

  //* Orderi Status
  const [isOrderiClose, setIsOrderiClose] = useState(null);

  //* Handle Change Password
  const handleChangePassword = async (userData, event) => {
    event?.preventDefault();

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await changePasswordService(userData);
      if (status === 200) {
        setPhonenumber(userData.phonenumber);
        setIsCodeSent(true);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Handle Confirm Change Password
  const handleConfirmChangePassword = async (userData, event) => {
    event?.preventDefault();

    const objData = {
      ...userData,
      phonenumber,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await confirmChangePasswordService(objData);
      if (status === 200) {
        setPhonenumber("");
        setIsCodeSent(false);
        setIsOpenChangePasswordModal(false);
        toast.success("رمز عبور شما با موفقیت تغییر پیدا کرد");
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Handle Change Pin
  const handleChangePin = async (e) => {
    e.preventDefault();

    const objData = {
      phonenumber: pinPhoneNumber,
      pin: changePin,
      confirmpin: confirmChangePin,
      password: pinPassword,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await changePinService(objData);
      if (status === 200) {
        toast.success("پین شما با موفقیت تغییر پیدا کرد");
        setIsOpenChangePinModal(false);
        setChangePin("");
        setConfirmChangePin("");
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Handle Get Store Status
  const handleGetStoreStatus = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getStoreStatusAdminService();
      if (status === 200) {
        setIsStoreClose(data?.isStoreClose);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Handle Change Store Status
  const handleChangeStoreStatus = async (isStoreClose) => {
    const objData = { id: 1, isStoreClose };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await changeStoreStatusAdminServices(objData);
      if (status === 200) {
        setIsStoreClose(!isStoreClose);
        toast.success(data.message);
        handleGetStoreStatus();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Handle Get Orders Status
  const handleGetOrdersStatus = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getOrdersStatusPublicService();
      if (status === 200) {
        setIsOrdersClose(data?.isOrderClose);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Handle Change Orders Status
  const handleChangeOrdersStatus = async (isOrderClose) => {
    const objData = { id: 1, isOrderClose };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await changeOrdersStatusAdminServices(objData);
      if (status === 200) {
        setIsOrdersClose(!isOrdersClose);
        toast.success(data?.message);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Handle Send Message By Admin
  const handleSendMessageByAdmin = async (isSmsClose) => {
    const objData = { id: 1, isSmsClose };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await smsStatusAdminServices(objData);
      if (status === 200) {
        toast.success(data?.message);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Handle Get Orderi Status
  const handleGetOrderiStatus = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getOrderiStatusPublicService();
      if (status === 200) {
        setIsOrderiClose(data?.isOrderiClose);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Handle Change Orderi Status
  const handleChangeOrderiStatus = async (isOrderiClose) => {
    const objData = { id: 1, isOrderiClose };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await changeOrderiStatusAdminServices(objData);
      if (status === 200) {
        setIsOrderiClose(!isOrderiClose);
        toast.success(data?.message);
        handleGetOrderiStatus();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <changePasswordAdminContext.Provider
      value={{
        phonenumber,
        setPhonenumber,
        isCodeSent,
        setIsCodeSent,
        isOpenChangePasswordModal,
        setIsOpenChangePasswordModal,
        handleChangePassword,
        handleConfirmChangePassword,
        changePin,
        setChangePin,
        confirmChangePin,
        setConfirmChangePin,
        isOpenChangePinModal,
        setIsOpenChangePinModal,
        handleChangePin,
        pinPhoneNumber,
        setPinPhoneNumber,
        pinPassword,
        setPinPassword,
        //* Store Status
        isStoreClose,
        setIsStoreClose,
        handleChangeStoreStatus,
        handleGetStoreStatus,
        //* Orders Status
        isOrdersClose,
        setIsOrdersClose,
        handleGetOrdersStatus,
        handleChangeOrdersStatus,
        //* Send Message By Admin
        handleSendMessageByAdmin,
        //* Orderi Status
        isOrderiClose,
        setIsOrderiClose,
        handleGetOrderiStatus,
        handleChangeOrderiStatus,
      }}
    >
      {children}
    </changePasswordAdminContext.Provider>
  );
};

export default ChangePasswordAdminContext;
